import { localizedText } from '@/lib/localized-text'
import type { CompanyOption } from './api'

export function localizedValues(en: string, ar: string): Record<string, string> {
  const values: Record<string, string> = {}
  if (en.trim()) values.en = en.trim()
  if (ar.trim()) values.ar = ar.trim()
  return values
}

export function parentName(
  parentId: string | null,
  options: CompanyOption[],
  locale: string,
  noneLabel: string,
  unknownLabel: string,
): string {
  if (!parentId) return noneLabel
  const parent = options.find((item) => item.id === parentId)
  return parent ? localizedText(parent.name, locale) : unknownLabel
}

export function isLocale(value: string): value is 'en' | 'ar' {
  return value === 'en' || value === 'ar'
}
